angular.module('lf.common')

.directive('mustMatch', function () {
  return {
    require: 'ngModel',
    scope: {
      ngModel: '=',
      mustMatch: '='
    },
    link: function (scope, el, attrs, model) {
      
      scope.$watch('[ngModel, mustMatch]', function (values) {
        if (values[0] && values[1]) {
          model.$setValidity('mustMatch', values[0] === values[1]);
        }
      });
      
    }
  }
});
